module.exports = __webpack_public_path__ + "static/media/appointment.a8083498.jpeg";